import styled from 'styled-components';

import MotifRadioButtonGroup from '@ey/motif-react-wrapper/RadioButtonGroup';

export default styled(MotifRadioButtonGroup)`
	&.motif-radio-button-group {
		gap: var(--spacing-medium-small);
		${({$variantHorizontal}) => $variantHorizontal && `flex-direction: row;`};
		.motif-radio-button.motif-radio-button-in-group {
			margin: 0;
			width: unset;
			.motif-radio-button-information {
				min-width: 0;
				flex: 1;
				.motif-radio-button-label {
					min-width: 0;
				}
			}
		}
	}
`;
